import React from "react";
import Input from "@cs/components/src/Input";
import Section from "@cs/components/src/Section";

interface Props {
  value: ScriptConfigItem;
  onChange: (value: ScriptConfigItem) => void;
}

const PluginForm = (props: Props) => {
  const { value: scriptConfig, onChange } = props;

  const update =
    (key: keyof ScriptConfigItem) =>
    (value: string | boolean | string[] | undefined) => {
      onChange({
        ...scriptConfig,
        [key]: value,
      });
    };

  return (
    <Section title="Plugin" color="var(--blue300)" pad>
      <Input
        label="Name"
        required
        value={scriptConfig.title}
        onChange={update("title")}
        autoFocus
      />
      <Input
        label="Script"
        required
        value={scriptConfig.script ?? ""}
        onChange={update("script")}
      />
      <Input
        label="Description"
        value={scriptConfig.description}
        onChange={update("description")}
        textarea
      />
    </Section>
  );
};

export default PluginForm;
